import Breadcrumb from "../Component/Breadcrumb";
const SchoolAnthem = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="School Anthem"
        breadmid="About"
        breadend="School Anthem"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="prayer_blk">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/St-magdalene.png"
                  className="img-fluid"
                />
                <h5>
                  <span>Our Motto</span>
                </h5>
                <p>
                  (Asathoma Sadgamaya (From untruth to Truth) Let our motto
                  triumph)
                </p>
              </div>
            </div>
            <div className="col-md-8">
              <div class="content prayer_content">
                <p class="text-center">
                  <strong> Deep rooted in the richness of our land.</strong>
                  <br />
                  Under the Banner of our Canossa school
                  <br />
                  <strong>We Pledge to tread the path of truth</strong>
                  <br />
                  We’ll unfurl the banner of Canossa High
                </p>
                <div class="clr10"></div>
                <p class="text-center">
                  <strong>Sharing the fragrance of God’s Love</strong>
                  <br />
                  Striving hard to soar above
                  <br />
                  <strong>Daring to live from the depth of truth</strong>
                  <br />
                  We reach out to all with love and care.
                </p>
                <div class="clr10"></div>
                <p class="text-center">
                  <strong>Walking in the steps of St. Magdalene</strong>
                  <br />
                  Trusting in God’s benevolence
                  <br />
                  <strong>Filled with wisdom and freedom</strong>
                  <br />
                  Canossa we raise our hearts to you.
                </p>
                <div class="clr10"></div>
                <p class="text-center">
                  <strong>We take a pledge to stand for truth</strong>
                  <br />
                  To keep the flag of Canossa high
                  <br />
                  <strong>Serving God and the Humankind</strong>
                  <br />
                  Hail Canossa, We march focontainerard.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SchoolAnthem;
